<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    width="1100px"
  >
    <validation-observer ref="formValidator">
      <div class="das-layout">
        <div class="l-w-70 column">
          <div class="das-form-container">
            <div class="das-form-title-container">
              <div class="das-form-title">
                <span class="main-title">{{
                  $t('views.houseKeeper.reservationInfo')
                }}</span>
              </div>
            </div>
            <hr />
            <InfoList :columns="3">
              <InfoListLabel>Đặt phòng</InfoListLabel>
              <InfoListValue>{{
                kpItemInfo.booking_code || kpItemInfo.sub_booking_code
              }}</InfoListValue>

              <InfoListLabel>Xác nhận</InfoListLabel>
              <InfoListValue>{{ kpItemInfo.confirm_code }}</InfoListValue>

              <InfoListLabel>Phòng</InfoListLabel>
              <InfoListValue>{{ kpItemInfo.room_num }}</InfoListValue>

              <InfoListLabel>Ngày đến</InfoListLabel>
              <InfoListValue>{{
                $displayDate(kpItemInfo.arrive_date) ||
                $displayDate(kpItemInfo.check_in_date)
              }}</InfoListValue>

              <InfoListLabel>Ngày đi</InfoListLabel>
              <InfoListValue>{{
                $displayDate(kpItemInfo.depart_date) ||
                $displayDate(kpItemInfo.check_out_date)
              }}</InfoListValue>

              <InfoListLabel>Đoàn</InfoListLabel>
              <InfoListValue>{{ kpItemInfo.depart_date }}</InfoListValue>
            </InfoList>
          </div>
          <div class="das-form-container">
            <div class="das-form-title-container">
              <div class="das-form-title">
                <span class="main-title">Danh sách dịch vụ</span>
              </div>
            </div>
            <hr />
            <div class="das-form-group">
              <div class="das-form-row align-end">
                <div class="das-form-col col-5">
                  <div class="das-form-input">
                    <div class="label">
                      <span class="main-title">{{
                        $t('views.houseKeeper.serviceList')
                      }}</span>
                    </div>
                    <el-select
                      v-model="kpItem.room_service_group_id"
                      :disabled="isEdit"
                      placeholder=""
                      @change="onSearchServiceProductList"
                    >
                      <el-option
                        v-for="item in roomServiceGroupOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div v-if="!isEdit" class="das-form-col col-5">
                  <div class="das-form-input">
                    <div class="label">Mã/Tên sản phẩm, dịch vụ</div>
                    <input
                      v-model="searchParams.keyword"
                      type="text"
                      :disabled="isDetailView"
                    />
                  </div>
                </div>
                <das-button
                  v-if="!isEdit"
                  color="primary"
                  size="small"
                  style="white-space: nowrap"
                  append-icon="search"
                  @click="onSearchServiceProductList"
                >
                  Tìm kiếm
                </das-button>
              </div>
              <div style="padding: 10px; background: white; height: 350px">
                <GridVx
                  ref="agGrid2"
                  :columns="columns"
                  :auto-select-first-row="false"
                  :rows="rows2"
                  dom-layout="scroll"
                  class="agGrid2"
                  :context="context"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="das-form-container l-w-30 relative">
          <div v-if="isDetailPopup" class="transparent-overlay" />
          <div class="das-form-title-container">
            <div class="das-form-title">
              <span class="main-title">{{
                $t('views.houseKeeper.invoiceInfo')
              }}</span>
            </div>
          </div>
          <hr />
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required" name="Ngày giao dịch">
                  <div class="das-form-input">
                    <div class="label required">Ngày giao dịch</div>
                    <CalendarSelect
                      v-model="kpItem.trading_date"
                      mode="date"
                      :min-max="{
                        min: kpItemInfo.arrive_date || kpItemInfo.check_in_date,
                        max: kpItemInfo.depart_date || kpItemInfo.check_out_date
                      }"
                    />
                    <!-- <SingleCalendar
                    v-model="kpItem.trading_date"
                    :disabled="isEdit"
                  /> -->
                  </div>
                </validation-provider>
              </div>
            </div>
            <!-- <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|integer" name="Số hóa đơn">
                  <div class="das-form-input">
                    <div class="label required">Số hóa đơn</div>
                    <input
                      v-model="kpItem.invoice_num"
                      :disabled="isDetailView"
                      type="number"
                    />
                  </div>
                </validation-provider>
              </div>
            </div> -->
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required" name="Trang dịch vụ">
                  <div class="das-form-input">
                    <div class="label required">Trang dịch vụ</div>
                    <el-select v-model="kpItem.trans_page" placeholder="">
                      <el-option
                        v-for="item in allTranPages"
                        :key="item.id"
                        :label="`${item.code} - ${item.desc}`"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="checkbox-wrap ml-10">
                <input id="foc" v-model="kpItem.foc" type="checkbox" />
                <label for="foc" style="font-weight: bold">FOC</label>
              </div>
            </div>
            <div v-if="!kpItem.foc" class="das-form-row">
              <div class="das-form-col col-12">
                <div class="label">Giảm giá</div>
                <div class="flex gap-1 align-center">
                  <el-select
                    v-model="kpItem.invoice_discount_type"
                    style="flex: 2"
                    placeholder=""
                    @change="changeInvoiceDiscountTp"
                  >
                    <el-option key="99" label="Không chọn" :value="0">
                    </el-option>
                    <el-option key="1" label="Phần trăm" :value="1">
                    </el-option>
                    <el-option key="2" label="Tiền" :value="2"> </el-option>
                  </el-select>
                  <VxCurrencyInput
                    v-show="kpItem.invoice_discount_type != 0"
                    v-if="kpItem.invoice_discount_type === 2"
                    v-model="kpItem.invoice_discount_value"
                    :disabled-flag="isDetailView"
                    style="flex: 1"
                  />
                  <validation-provider
                    v-if="kpItem.invoice_discount_type === 1"
                    style="flex: 1"
                    rules="percent"
                    name="Phần trăm giảm giá"
                  >
                    <input
                      v-show="kpItem.invoice_discount_type != 0"
                      v-model="kpItem.invoice_discount_value"
                      :disabled="isDetailView"
                      type="text"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">Ghi chú</div>
                  <input
                    v-model="kpItem.note"
                    type="text"
                    :disabled="isDetailView"
                  />
                </div>
              </div>
            </div>
            <hr />
            <div class="flex space-between mb-10">
              <div class="das-form-input">Tổng thành tiền</div>
              <div class="das-form-input">
                {{ $displayCurrency(amountBeforeDiscount) || 0 }}
              </div>
            </div>
            <div class="flex space-between mb-10">
              <div class="das-form-input">Giảm giá</div>
              <div class="das-form-input">
                {{ $displayCurrency(discountAmount) || 0 }}
              </div>
            </div>
            <div class="flex space-between mb-10">
              <div class="das-form-input" style="font-weight: bold">
                Tổng tiền (VNĐ)
              </div>
              <div class="das-form-input" style="font-weight: bold">
                {{ $displayCurrency(amountAfterDiscount) || 0 }}
              </div>
            </div>
            <div class="flex space-between mb-10 mt-20">
              <div class="das-form-input" style="font-style: italic">
                Trong đó:
              </div>
            </div>
            <div class="flex space-between mb-10">
              <div class="das-form-input">- Phí dịch vụ</div>
              <div class="das-form-input">
                {{ $displayCurrency(serviceChargeAmount) || 0 }}
              </div>
            </div>
            <div class="flex space-between mb-10">
              <div class="das-form-input">- Thuế</div>
              <div class="das-form-input">
                {{ $displayCurrency(taxAmount) || 0 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
    <span slot="footer" class="dialog-footer">
      <div v-if="!isDetailView" class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogFormVisible = false"
        >
          Huỷ
        </button>
        <button
          v-if="isEdit && !isDetailPopup"
          class="btn primary small"
          @click="updateItem"
        >
          Cập nhật
        </button>
        <button
          v-if="!isEdit && !isDetailPopup"
          class="btn primary small"
          @click="addNewItem"
        >
          Tạo mới
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
// import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import DasButton from '@/components/ui/DasButton.vue'
import { getCodeBase } from '@/api/common/code_base'
import {
  CellRenderCheckboxReadonly,
  CellRenderTextInput,
  CellRenderCurrencyInput,
  CellRenderControlNumber
} from '@/utils/cellRenders'
import {
  getRoomServiceGroupApi,
  getRoomServiceProductListApi
} from '@/api/Service_Policy/roomServiceGroup'
import {
  addHouseKeepingServiceInvoicesApi,
  updateHouseKeepingServiceInvoicesApi,
  getSubBookingServiceInvoice
} from '@/api/houseKeeper/house-keeping-service.js'

export default {
  components: {
    // SingleCalendar,
    DasButton,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderTextInput,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCurrencyInput,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderControlNumber
  },
  props: {
    kpItemInfo: {
      type: Object,
      default: () => {
        return {
          booking_code: null,
          confirm_code: null,
          arrive_date: null,
          depart_date: null,
          room_num: null,
          group: null
        }
      }
    },
    kpItemProp: {
      type: Object,
      default: () => {
        return {
          trading_date: this.$displayDate(new Date()),
          quantity: null,
          trans_page: null,
          invoice_discount_type: null,
          foc: false,
          invoice_discount_value: null,
          money_total: 0,
          note: null,
          room_service_group_id: null,
          room_service_group_name: null,
          sub_booking_group_id: null,
          room_transaction_id: null,
          fee: null,
          tax: null,
          products: []
        }
      }
    },
    index: {
      type: Number,
      default: null
    },
    isDetailPopup: {
      type: Boolean,
      default: false
    }
    // isEdit: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data() {
    return {
      dialogTitle: null,
      isEdit: false,
      dialogFormVisible: false,
      isDetailView: false,
      context: null,
      allTranPages: [],
      searchParams: {
        searchParams: null
      },
      roomServiceGroupOptions: [],
      kpItem: {
        trading_date: null,
        quantity: null,
        trans_page: null,
        invoice_discount_type: null,
        foc: false,
        invoice_discount_value: null,
        money_total: 0,
        note: null,
        room_service_group_id: null,
        room_service_group_name: null,
        sub_booking_group_id: null,
        room_transaction_id: null,
        fee: null,
        tax: null,
        products: []
      },
      columns: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          maxWidth: 150
        },
        {
          headerName: 'Tên',
          field: 'name'
        },
        {
          headerName: 'Số tiền',
          field: 'price',
          maxWidth: 150,
          cellRenderer: 'CellRenderCurrencyInput',
          cellRendererParams: params => {
            return {
              readOnly: !params.data.open_service
            }
          }
        },
        {
          headerName: 'Số lượng',
          field: 'quantity',
          maxWidth: 150,
          minWidth: 150,
          cellRenderer: 'CellRenderControlNumber'
          // cellRendererParams: () => {
          //   return {
          //     type: 'number'
          //   }
          // }
        },
        {
          headerName: '% Phí',
          field: 'fee',
          tooltipField: 'fee',
          maxWidth: 100
        },
        {
          headerName: '% Thuế',
          field: 'tax',
          tooltipField: 'tax',
          maxWidth: 100
        },
        {
          headerName: 'Giảm giá dịch vụ',
          field: 'discount',
          cellRenderer: 'CellRenderCurrencyInput'
        },
        {
          headerName: 'Thành tiền',
          field: 'money_total',
          valueGetter: params => {
            if (params.data?.money_total) {
              return Number(params.data.money_total).toLocaleString('en')
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Giá mở',
          field: 'open_service',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 80,
          cellRenderer: 'CellRenderCheckboxReadonly'
        }
      ],
      rows2: []
    }
  },
  computed: {
    bookingInfo() {
      return this.$store.getters['cashier']
    },
    discountAmount() {
      let amount = 0
      if (this.kpItem.foc || this.kpItem.invoice_discount_type === 0) {
        amount = 0
      } else {
        if (this.kpItem.invoice_discount_type === 1 && !this.kpItem.foc) {
          amount =
            this.amountBeforeDiscount *
            this.kpItem.invoice_discount_value *
            0.01
        } else {
          amount = this.kpItem.invoice_discount_value
        }
      }
      return amount
    },
    amountBeforeDiscount() {
      let amount = 0
      // fee, tax, include_tax_fee tat ca cac row giong nhau
      if (!this.kpItem.include_tax_fee) {
        amount =
          this.kpItem.money_total + this.serviceChargeAmount + this.taxAmount
      } else {
        amount = Number(this.kpItem.money_total)
        // this.rows2.map(item => {
        //   amount += Number(item.money_total) || 0
        // })
        // // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // this.kpItem.money_total = amount
      }

      if (this.kpItem.foc) {
        amount = 0
      }
      return amount
    },
    amountAfterDiscount() {
      let amount = 0
      if (!this.kpItem.include_tax_fee && !this.kpItem.foc) {
        amount = this.amountBeforeDiscount - this.discountAmount
      } else if (this.kpItem.foc) {
        amount = 0
      } else {
        amount = this.kpItem.money_total - this.discountAmount
      }
      return amount
    },
    serviceChargeAmount() {
      let amount
      if (!this.kpItem.include_tax_fee && !this.kpItem.foc) {
        return this.kpItem.money_total * this.kpItem.fee * 0.01
      } else {
        const total =
          (this.amountBeforeDiscount * 100) /
          (100 + this.kpItem.fee + this.kpItem.tax)
        amount = (this.kpItem.fee * total) / 100
      }

      if (this.kpItem.foc) {
        amount = 0
      }
      return amount.toFixed()
    },
    taxAmount() {
      let amount
      if (!this.kpItem.include_tax_fee && !this.kpItem.foc) {
        return this.kpItem.money_total * this.kpItem.tax * 0.01
      } else {
        const total =
          (this.amountBeforeDiscount * 100) /
          (100 + this.kpItem.fee + this.kpItem.tax)
        amount = (this.kpItem.tax * total) / 100
      }

      if (this.kpItem.foc) {
        amount = 0
      }
      return amount.toFixed()
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? this.setDialogTitle() : this.resetForm()
    },
    'kpItem.foc'() {
      if (this.kpItem.foc) {
        this.kpItem.invoice_discount_type = 0
      } else {
        this.kpItem.money_total = this.rows2.reduce((a, b) => {
          return a + b.money_total
        }, 0)
      }
    }
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  async mounted() {
    const data = await getCodeBase({
      p_code: 'TRANPAGE'
    })
    this.allTranPages = data.data
    const data1 = await getRoomServiceGroupApi({
      active: 10
    })
    this.roomServiceGroupOptions = data1.data
  },
  methods: {
    changeInvoiceDiscountTp() {
      // Set discount value = 0 when change type
      this.kpItem.invoice_discount_value = 0
    },

    setTranPage() {
      if (!this.isEdit && !this.isDetailPopup) {
        this.kpItem.trans_page = this.allTranPages[0]?.id || null
      }
    },
    setTransDate() {
      // eslint-disable-next-line no-unused-vars
      const currentDate = this.$moment(new Date()).format('YYYY-MM-DD')
      const arriveDate = this.kpItemInfo.arrive_date
        ? this.kpItemInfo.arrive_date
        : this.kpItemInfo.check_in_date
      const departDate = this.kpItemInfo.depart_date
        ? this.kpItemInfo.depart_date
        : this.kpItemInfo.check_out_date
      if (arriveDate && departDate) {
        if (
          currentDate >= this.$moment(arriveDate).format('YYYY-MM-DD') &&
          currentDate <= this.$moment(departDate).format('YYYY-MM-DD')
        ) {
          this.kpItem.trading_date = this.$moment(new Date()).format(
            'YYYY-MM-DD'
          )
        }
      }
    },
    setDialogTitle() {
      // set dialog title
      this.dialogTitle = this.$t('dialog.titleHouseKeepingServiceAdd')
      if (this.isEdit) {
        this.dialogTitle = this.$t('dialog.titleHouseKeepingServiceEdit')
      }
      if (this.isDetailPopup) {
        this.dialogTitle = 'Chi tiết giao dịch'
      }
      this.setTranPage()
      this.isEdit ? null : this.setTransDate()
    },
    async onEdit(id) {
      await getSubBookingServiceInvoice(id).then(res => {
        this.kpItem = res.data
        this.rows2 = res.data.products.map(item => {
          return {
            ...item,
            tax: Number(item.tax) || 0,
            fee: Number(item.fee ?? 0),
            money_total: item.price * item.quantity - item.discount
          }
        })
        // Thue, phi, include_tax_fee cua tat ca cac row la giong nhau
        this.kpItem.fee = this.kpItem.products[0].fee
        this.kpItem.tax = this.kpItem.products[0].tax
        this.kpItem.include_tax_fee = this.kpItem.products[0].include_tax_fee
        if (this.kpItem.invoice_discount_type === 2) {
          // amount
          this.kpItem.money_total += this.kpItem.invoice_discount_value
        } else if (this.kpItem.invoice_discount_type === 1) {
          // percent
          this.kpItem.money_total =
            this.kpItem.money_total /
            (1 - Number(this.kpItem.invoice_discount_value) * 0.01)
        }
      })
      this.isEdit = true
      this.dialogFormVisible = true
      // Edit
    },
    numberControllerChange(params, value, colNm) {
      const idx = params.rowIndex
      this.rows2[idx]['money_total'] =
        value * Number(this.rows2[idx]['price']) -
        Number(this.rows2[idx]['discount'])
      // change grid value
      const agGrid = this.$refs.agGrid2.gridApi
      agGrid.forEachNode(node => {
        if (node.rowIndex === idx) {
          node.setDataValue('money_total', this.rows2[idx]['money_total'])
        }
      })
      this.rows2[params.rowIndex][colNm] = value

      // use reduce
      let amount = 0
      this.rows2.map(item => {
        amount += Number(item.money_total) || 0
      })
      this.kpItem.money_total = amount
    },
    assignHk() {},
    resetForm() {
      this.isEdit = false
      this.kpItem = {
        trading_date: null,
        quantity: null,
        trans_page: null,
        invoice_discount_type: null,
        foc: false,
        invoice_discount_value: null,
        money_total: 0,
        note: null,
        room_service_group_id: null,
        room_service_group_name: null,
        sub_booking_group_id: null,
        room_transaction_id: null,
        fee: null,
        tax: null,
        products: []
      }
      this.rows2 = []
      this.$nullValueInObj(this.searchParams)
      this.$emit('resetDialog')
    },
    changeCurrencyInput(params, value, colName) {
      const idx = params.rowIndex
      const agGrid = this.$refs.agGrid2.gridApi
      if (!this.rows2[idx]['quantity'] || !this.rows2[idx]['quantity'] === '') {
        return
      }

      switch (colName) {
        case 'price':
          this.rows2[idx]['price'] = value
          this.rows2[idx]['money_total'] =
            Number(value) * this.rows2[idx]['quantity'] -
            this.rows2[idx]['discount']
          agGrid.forEachNode(node => {
            if (node.rowIndex === idx) {
              node.setDataValue('money_total', this.rows2[idx]['money_total'])
            }
          })
          break
        case 'discount':
          // eslint-disable-next-line no-case-declarations
          this.rows2[idx]['discount'] = Number(value)
          this.rows2[idx]['money_total'] =
            Number(this.rows2[idx]['price']) *
              Number(this.rows2[idx]['quantity']) -
            Number(value)
          agGrid.forEachNode(node => {
            if (node.rowIndex === idx) {
              node.setDataValue(
                'money_total',
                Number(this.rows2[idx]['money_total'])
              )
            }
          })
          break
        default:
          break
      }
      let amount = 0
      this.rows2.map(item => {
        amount += item.money_total
      })
      this.kpItem.money_total = amount
      // this.kpItem.money_total = this.calculateMoneyTotal
    },
    async onSearchServiceProductList() {
      const list = await getRoomServiceProductListApi(
        this.kpItem.room_service_group_id,
        this.searchParams
      )
      this.rows2 = list.data.map(item => {
        return {
          ...item,
          discount: 0,
          quantity: 0
        }
      })
      if (this.rows2.length > 0) {
        this.kpItem.include_tax_fee = this.rows2[0].include_tax_fee
        this.kpItem.fee = this.rows2[0].fee
        this.kpItem.tax = this.rows2[0].tax
      } else {
        this.kpItem.include_tax_fee = null
        this.kpItem.fee = null
        this.kpItem.tax = null
      }

      const item = {
        // trans_page: null,
        invoice_discount_type: null,
        foc: false,
        invoice_discount_value: null,
        money_total: 0,
        note: null
      }
      Object.assign(this.kpItem, item)
    },
    async addNewItem() {
      // validate
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      if (this.rows2.length === 0) {
        this.$message({
          message: 'Cần chọn danh sách dịch vụ',
          type: 'error'
        })
        return
      }
      if (Number(this.amountAfterDiscount) < 0) {
        this.$message({
          message: 'Tổng tiền không hợp lệ, kiểm tra lại thông tin',
          type: 'error'
        })
        return
      }
      const data = this.kpItem
      data.products = this.rows2
      data.sub_booking_group_id = this.kpItemInfo.id
      if (data.foc) {
        data.money_total = 0
      } else {
        data.money_total = this.amountAfterDiscount
      }
      // if (data.invoice_discount_type === 1) {
      //   data.money_total -=
      //     0.01 * Number(data.invoice_discount_value) * data.money_total
      // } else if (data.invoice_discount_type === 2) {
      //   data.money_total -= Number(data.invoice_discount_value)
      // }
      await addHouseKeepingServiceInvoicesApi(data)
        .then(async res => {
          const message = res.message
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.$emit('submitDone')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateItem() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      if (this.rows2.length === 0) {
        this.$message({
          message: 'Cần chọn danh sách dịch vụ',
          type: 'error'
        })
        return
      }
      const data = this.kpItem
      data.products = this.rows2

      if (data.foc) {
        data.money_total = 0
      } else {
        data.money_total = this.amountAfterDiscount
      }
      // if (this.kpItem.invoice_discount_type === 1) {
      //   data.money_total -=
      //     0.01 * Number(data.invoice_discount_value) * data.money_total
      // } else if (data.invoice_discount_type === 2) {
      //   data.money_total -= Number(data.invoice_discount_value)
      // }
      await updateHouseKeepingServiceInvoicesApi(data)
        .then(async res => {
          const message = res.message
          // await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.$emit('submitDone')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    }
  }
}
</script>
